// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3l7t3","title":"ClientReferral_title__rdQLo","itemText":"ClientReferral_itemText__2vC6k"};